import React, { useState } from 'react'
import { NavLink, Navigate } from 'react-router-dom'
import { ButtonStyle } from '../widgetStyles/Styles'
import { Form } from '../components/Form'
import { Input } from '../components/Input'

export const SignUp = () => {
    const [isSubmit, setSubmit] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        setSubmit(true);
    }

    return (
        <div className="wrapper df fade-in mtn mb jcc">
            <Form title={"Sign up"} subtitle={"Enter your details"} onSubmit={submit}>
                <div className="df ais">
                    <Input hint={"First Name"} required  type="text" warning={"Field is empty"} placeholder="Tammy" className="mrs" />
                    <Input hint={"Middle Name"} type="text" placeholder="Donald" />
                </div>
                <div className="df ais">
                    <Input hint={"Last Name"} type="text" warning={"Field is empty"} placeholder="Reuben" className="mrs" />
                    <Input hint={"Company Name"} required  type="text" placeholder="Crowd Detection" />
                </div>
                <div className="df ais">
                    <Input hint={"Email"} required type="email" placeholder="Saydullin@gmail.com" className="mrs" />
                    <Input hint={"Password"} required type="password" placeholder="********" />
                </div>
                <ButtonStyle type="submit" className={"except_under input_button"}>Done</ButtonStyle>
                <NavLink to="/crowd-detection/login" className={"bl-l fs-t"}>Already have an account? Log in!</NavLink>
                {isSubmit && <Navigate to="/crowd-detection/personal-area/" />}
            </Form>
        </div>
    )
}


